import {EFilterValueType} from 'features/predicate-expression-form-list';
import {EPostgresDateType, EPostgresNumberType, EPostgresStringType} from 'shared/types/postgres';
import {IReportTableColumn} from 'store/slices/report-configuration-slice/dd-lookups/dd-lookups-types';

/**
 * Определяет тип значения фильтра на основе типа колонки отчета
 * 
 * @description Преобразует тип колонки из отчета в соответствующий тип значения для фильтра.
 * 
 * @param reportColumnType - Тип колонки из отчета
 * @returns Тип значения для фильтра (EFilterValueType):
 *          - EFilterValueType.number для числовых типов
 *          - EFilterValueType.date для типов даты/времени
 *          - EFilterValueType.text для строковых типов и всех нераспознанных случаев
 */
export const getFilterValueTypeByColumnType = (reportColumnType: IReportTableColumn['type'] | undefined) => {
    // Строка нужна для корретной работой c типом number(0,00)
    const trimmedReportColumnType = reportColumnType?.split('(')[0].trim();

    if (!trimmedReportColumnType) return EFilterValueType.text;

    if (trimmedReportColumnType in EPostgresNumberType) return EFilterValueType.number;
    if (trimmedReportColumnType in EPostgresDateType) return EFilterValueType.date;
    if (trimmedReportColumnType in EPostgresStringType) return EFilterValueType.text;

    return EFilterValueType.text;
};